module.exports = __webpack_public_path__ + "img/blog-article-text-img-1.8ae1c1de.png";